import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import e from "../core/Plugin";
import t from "../utils/classSet";

var s = /*#__PURE__*/function (_e) {
  _inherits(s, _e);

  var _super = _createSuper(s);

  function s(e) {
    var _this;

    _classCallCheck(this, s);

    _this = _super.call(this, e);
    _this.messages = new Map();
    _this.defaultContainer = document.createElement("div");
    _this.opts = Object.assign({}, {
      container: function container(e, t) {
        return _this.defaultContainer;
      }
    }, e);
    _this.elementIgnoredHandler = _this.onElementIgnored.bind(_assertThisInitialized(_this));
    _this.fieldAddedHandler = _this.onFieldAdded.bind(_assertThisInitialized(_this));
    _this.fieldRemovedHandler = _this.onFieldRemoved.bind(_assertThisInitialized(_this));
    _this.validatorValidatedHandler = _this.onValidatorValidated.bind(_assertThisInitialized(_this));
    _this.validatorNotValidatedHandler = _this.onValidatorNotValidated.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(s, [{
    key: "install",
    value: function install() {
      this.core.getFormElement().appendChild(this.defaultContainer);
      this.core.on("core.element.ignored", this.elementIgnoredHandler).on("core.field.added", this.fieldAddedHandler).on("core.field.removed", this.fieldRemovedHandler).on("core.validator.validated", this.validatorValidatedHandler).on("core.validator.notvalidated", this.validatorNotValidatedHandler);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.core.getFormElement().removeChild(this.defaultContainer);
      this.messages.forEach(function (e) {
        return e.parentNode.removeChild(e);
      });
      this.messages.clear();
      this.core.off("core.element.ignored", this.elementIgnoredHandler).off("core.field.added", this.fieldAddedHandler).off("core.field.removed", this.fieldRemovedHandler).off("core.validator.validated", this.validatorValidatedHandler).off("core.validator.notvalidated", this.validatorNotValidatedHandler);
    }
  }, {
    key: "onFieldAdded",
    value: function onFieldAdded(e) {
      var _this2 = this;

      var t = e.elements;

      if (t) {
        t.forEach(function (e) {
          var t = _this2.messages.get(e);

          if (t) {
            t.parentNode.removeChild(t);

            _this2.messages.delete(e);
          }
        });
        this.prepareFieldContainer(e.field, t);
      }
    }
  }, {
    key: "onFieldRemoved",
    value: function onFieldRemoved(e) {
      var _this3 = this;

      if (!e.elements.length || !e.field) {
        return;
      }

      var t = e.elements[0].getAttribute("type");

      var _s2 = "radio" === t || "checkbox" === t ? [e.elements[0]] : e.elements;

      _s2.forEach(function (e) {
        if (_this3.messages.has(e)) {
          var _t = _this3.messages.get(e);

          _t.parentNode.removeChild(_t);

          _this3.messages.delete(e);
        }
      });
    }
  }, {
    key: "prepareFieldContainer",
    value: function prepareFieldContainer(e, t) {
      var _this4 = this;

      if (t.length) {
        var _s12 = t[0].getAttribute("type");

        if ("radio" === _s12 || "checkbox" === _s12) {
          this.prepareElementContainer(e, t[0], t);
        } else {
          t.forEach(function (_s4) {
            return _this4.prepareElementContainer(e, _s4, t);
          });
        }
      }
    }
  }, {
    key: "prepareElementContainer",
    value: function prepareElementContainer(e, _s5, i) {
      var a;

      if ("string" === typeof this.opts.container) {
        var _e2 = "#" === this.opts.container.charAt(0) ? "[id=\"".concat(this.opts.container.substring(1), "\"]") : this.opts.container;

        a = this.core.getFormElement().querySelector(_e2);
      } else {
        a = this.opts.container(e, _s5);
      }

      var l = document.createElement("div");
      a.appendChild(l);
      t(l, {
        "fv-plugins-message-container": true
      });
      this.core.emit("plugins.message.placed", {
        element: _s5,
        elements: i,
        field: e,
        messageElement: l
      });
      this.messages.set(_s5, l);
    }
  }, {
    key: "getMessage",
    value: function getMessage(e) {
      return typeof e.message === "string" ? e.message : e.message[this.core.getLocale()];
    }
  }, {
    key: "onValidatorValidated",
    value: function onValidatorValidated(e) {
      var _s6 = e.elements;
      var i = e.element.getAttribute("type");
      var a = "radio" === i || "checkbox" === i ? _s6[0] : e.element;

      if (this.messages.has(a)) {
        var _s13 = this.messages.get(a);

        var _i = _s13.querySelector("[data-field=\"".concat(e.field, "\"][data-validator=\"").concat(e.validator, "\"]"));

        if (!_i && !e.result.valid) {
          var _i2 = document.createElement("div");

          _i2.innerHTML = this.getMessage(e.result);

          _i2.setAttribute("data-field", e.field);

          _i2.setAttribute("data-validator", e.validator);

          if (this.opts.clazz) {
            t(_i2, _defineProperty({}, this.opts.clazz, true));
          }

          _s13.appendChild(_i2);

          this.core.emit("plugins.message.displayed", {
            element: e.element,
            field: e.field,
            message: e.result.message,
            messageElement: _i2,
            meta: e.result.meta,
            validator: e.validator
          });
        } else if (_i && !e.result.valid) {
          _i.innerHTML = this.getMessage(e.result);
          this.core.emit("plugins.message.displayed", {
            element: e.element,
            field: e.field,
            message: e.result.message,
            messageElement: _i,
            meta: e.result.meta,
            validator: e.validator
          });
        } else if (_i && e.result.valid) {
          _s13.removeChild(_i);
        }
      }
    }
  }, {
    key: "onValidatorNotValidated",
    value: function onValidatorNotValidated(e) {
      var t = e.elements;

      var _s8 = e.element.getAttribute("type");

      var i = "radio" === _s8 || "checkbox" === _s8 ? t[0] : e.element;

      if (this.messages.has(i)) {
        var _t3 = this.messages.get(i);

        var _s14 = _t3.querySelector("[data-field=\"".concat(e.field, "\"][data-validator=\"").concat(e.validator, "\"]"));

        if (_s14) {
          _t3.removeChild(_s14);
        }
      }
    }
  }, {
    key: "onElementIgnored",
    value: function onElementIgnored(e) {
      var t = e.elements;

      var _s10 = e.element.getAttribute("type");

      var i = "radio" === _s10 || "checkbox" === _s10 ? t[0] : e.element;

      if (this.messages.has(i)) {
        var _t4 = this.messages.get(i);

        var _s15 = [].slice.call(_t4.querySelectorAll("[data-field=\"".concat(e.field, "\"]")));

        _s15.forEach(function (e) {
          _t4.removeChild(e);
        });
      }
    }
  }], [{
    key: "getClosestContainer",
    value: function getClosestContainer(e, t, _s) {
      var i = e;

      while (i) {
        if (i === t) {
          break;
        }

        i = i.parentElement;

        if (_s.test(i.className)) {
          break;
        }
      }

      return i;
    }
  }]);

  return s;
}(e);

export { s as default };